//Base url for axios/API
export const BASE_URL = process.env.REACT_APP_API ? process.env.REACT_APP_API : 'http://localhost:3000/api'
export const BASE_AUTH_URL = process.env.REACT_APP_AUTH_API ? process.env.REACT_APP_AUTH_API : 'http://localhost:3000/ids'
export const APP_CLIENT_ID = process.env.APP_CLIENT_ID ? process.env.APP_CLIENT_ID : 'AgreCalc_Swagger'
export const APP_SCOPE = process.env.APP_SCOPE ? process.env.APP_SCOPE : 'AgreCalc'
export const APP_IDLE_TIME = 4*60*60*1000
